"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minPasswordLength = void 0;
exports.minPasswordLength = 6;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWluUGFzc3dvcmRMZW5ndGguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc3RhbnRzL21pblBhc3N3b3JkTGVuZ3RoLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsaUJBQWlCLEdBQUcsQ0FBQyxDQUFDIn0=